module.exports = __webpack_public_path__ + "static/media/campign-manager.7abbdfde.svg";